<template>
  <div>
    <div class="level tile-header tile-highlight">
      <div class="level-left">
        <p class="is-size-3 level-item">{{ total }}</p>
        <p class="is-size-6 level-item">{{ title }}</p>
      </div>
      <div class="level-right">
        <slot></slot>
      </div>
    </div>
    <vue-apex-charts
      :width="width"
      :height="height"
      :type="type"
      :options="optionsLine"
      :series="series">
    </vue-apex-charts>
  </div>
</template>

<script>
import _ from 'lodash';
import utils from '@/mixins/utils';
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 'ChartLineBarTimeSeries',
  mixins: [utils],
  components: {
    VueApexCharts,
  },
  props: {
    endpoint: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'line',
    },
    title: {
      type: String,
      required: true,
    },
    filter: {
      type: Object,
      required: true,
    },
    asset: {
      type: Object,
      default: null,
    },
    baseColor: {
      type: String,
      default: '#30343F',
    },
    height: {
      type: String,
      default: 'auto',
    },
    width: {
      type: String,
      default: '100%',
    },
  },
  data() {
    return {
      chartData: null,
      total: 0,
      optionsLine: {
        tooltip: {
          theme: 'dark',
        },
        xaxis: {
          type: 'datetime',
        },
        yaxis: {
          min: 0,
          labels: {
            show: true,
            style: {
              colors: ['#FFF'],
              fontSize: '12px',
            },
          },
        },
        toolbar: {
          show: false,
        },
        legend: {
          show: false,
          position: 'bottom',
        },
        dataLabels: {
          enabled: false,
        },
        labels: [],
        chart: {
          id: `vuechart--line-${this.ident}`,
          type: this.type,
          toolbar: {
            // Would like to show the toolbar but the styles are not working in prod
            // https://github.com/apexcharts/apexcharts.js/issues/238
            // Basically, the css is injected in the root dom via webpack
            // and then overrides any local styles
            show: false,
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
        },
        stroke: {
          width: 3,
          curve: 'smooth',
          colors: '#FFF',
        },
        grid: {
          show: true,
          clipMarkers: false,
        },
        theme: {
          monochrome: {
            enabled: true,
            color: this.baseColor,
            shadeTo: 'light',
            shadeIntensity: 0.65,
          },
        },
      },
      series: [
        {
          name: this.title,
          data: [],
        },
      ],
    };
  },
  computed: {
    ident() {
      return this.asset ? this.asset.uuid : this.randomString();
    },
  },
  watch: {
    filter() {
      this.updateChart();
    },
  },
  methods: {
    async updateChart() {
      this.chartData = await this.$store.dispatch(this.endpoint, {
        uuid: this.asset ? this.asset.uuid : null,
        since: this.filter.since,
        interval: this.filter.interval,
      });
      this.total = _.sumBy(this.chartData, 'count');
      this.series = [{
        name: this.title,
        data: _.reverse(_.map(this.chartData, item => [item.timeInterval, item.count])),
      }];
    },
  },
  async mounted() {
    this.updateChart();
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/colors.scss';

p {
  text-align: center;
  margin-bottom: 0;
}

p.filter {
  padding: .2rem;
  cursor: pointer;
}

p.filter:nth-last-child(2) {
  margin-left: .5rem;
  margin-right: .5rem;
}

p.selected {
  background-color: $tile-danger;
}

.tile-header {
  padding: 0 .5rem;
  margin-bottom: 0;
}
</style>
